<template>
  <layout-main-inner title="返工管理">
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="title">
        <!-- <el-button
          type="primary"
          icon="el-icon-plus"
          @click="createOutstock">新建订单</el-button> -->
      </template>
      <template slot="form">
        <!-- <el-checkbox-group v-model="config.statusList">
          <el-checkbox-button :label="0">返工中</el-checkbox-button>
          <el-checkbox-button :label="2">已完成</el-checkbox-button>
          <el-checkbox-button :label="9">已关闭</el-checkbox-button>
        </el-checkbox-group> -->
        <el-radio-group
          v-model="config.statusList"
          @change="handleCurrentChange(1)">
          <el-radio-button :label="null">全部</el-radio-button>
          <el-radio-button :label="[0]">返工中</el-radio-button>
          <el-radio-button :label="[2]">已完成</el-radio-button>
          <!-- <el-radio-button :label="[9]">已关闭</el-radio-button> -->
        </el-radio-group>
        <ent-product-auto-select
          v-model="config.productId"
          style="margin-left: 10px;"
          :productTypes="[1,9]"
          :callback="() => {handleCurrentChange(1)}" />
        <el-button
          type="primary"
          style="margin-left: 10px;"
          @click="handleCurrentChange(1)">查询</el-button>
        <!-- <el-select
          v-model="config.status"
          placeholder="请选择状态"
          @change="fetchList">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input
          v-model="config.orderNumber"
          placeholder="请输入订单"
          style="width: 200px">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input> -->
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          :resizable="false"
          label="返工单号"
          width="140"
          prop="reworkNumber"></el-table-column>
        <el-table-column
          :resizable="false"
          label="商品名称"
          prop="productName"></el-table-column>
        <el-table-column
          :resizable="false"
          label="商品数">
          <el-table-column
            width="150"
            :resizable="false"
            label="有码"
            prop="hasTagCount">
            <template slot-scope="{row}">
              <span>{{ row.hasTagCount }}</span>
              <el-popover
                v-if="row.hasTagCount > 0"
                trigger="click">
                <el-table
                  border=""
                  :data="row.reworkTags">
                  <el-table-column
                    width="100"
                    property="formatedTagNo"
                    label="旧序号"></el-table-column>
                  <el-table-column
                    width="100"
                    property="formatedNewTagNo"
                    label="新序号"></el-table-column>
                  <!-- <el-table-column width="300" property="address" label="地址"></el-table-column> -->
                </el-table>
                <i
                  slot="reference"
                  style="margin-left:5px;cursor: pointer;"
                  class="el-icon-info"></i>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            :resizable="false"
            label="无码"
            prop="noTagCount"></el-table-column>
        </el-table-column>
        <el-table-column
          label="状态"
          width="100">
          <template slot-scope="{row}">
            <span v-if="row.status === 0">返工中</span>
            <span v-if="row.status === 2">已完成</span>
            <span v-if="row.status === 9">已关闭</span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="140"
          :resizable="false">
          <template slot-scope="{row}">
            {{ row.createdTime | dateformat() }}
          </template>
        </el-table-column>

        <!-- <el-table-column
          label="操作"
          width="210">
          <template slot-scope="{row}">
            <el-button
              v-if="row.status === 0"
              type="text"
              @click="deleteOutstock(row)">删除</el-button>
            <el-button
              v-if="row.status !== 3"
              type="text"
              @click="closeOutstock(row)">关闭</el-button>
            <el-button
              v-if="row.status !== 3"
              type="text"
              @click="addSubOrder(row)">补单</el-button>
            <el-button
              v-if="row.outGoodsCount> 0 && row.status !== 3"
              type="text"
              @click="addgoodsreturnbynotag (row)">无码退单</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
    <sub-order-modal
      ref="modal"
      :fetch="fetchList"
      :originalOrder="current" />
    <notag-returen-modal
      ref="modal1"
      :fetch="fetchList"
      :originalOrder="goodsreturn" />
  </layout-main-inner>
</template>

<script>
import SubOrderModal from './busi/sub-order-modal.vue'
import NotagReturenModal from './busi/notag-returen-modal.vue'
import clonedeep from 'lodash.clonedeep'
import EntProductAutoSelect from '@/components/business/ent-product-auto-select.vue'
import { mapState } from 'vuex'
export default {
  name: 'ReworkList',
  components: { SubOrderModal, NotagReturenModal, EntProductAutoSelect },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        productId: null,
        statusList: null
        // orderNumber: '',
        // isOriginalOrder: 1,
        // vendorId: null,
        // status: null
      },
      list: [],
      total: 0,
      current: {},
      goodsreturn: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      query: state => state.common.query
    })
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    createOutstock() {
      this.$router.push(`/outstock-create?vendorId=${this.userInfo.orgId}`)
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('product/getreworks', {
        payload: {
          ...this.config
          // status: this.config.status !== null ? [this.config.status] : null
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    deleteOutstock(row) {
      this.$confirm('此操作将永久删除该订单信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('outstock/deleteoutstockorder', {
            payload: {
              outstockOrderId: row.outstockOrderId,
              vendorId: row.vendorId
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    closeOutstock(row) {
      this.$confirm('此操作将永久关闭该订单信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('outstock/closeoutstockorder', {
            payload: {
              outstockOrderId: row.outstockOrderId,
              vendorId: row.vendorId
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    addgoodsreturnbynotag(row) {
      this.goodsreturn = clonedeep(row)
      this.$refs.modal1.toggleModal(true)
    },
    addSubOrder(row) {
      this.current = clonedeep(row)
      this.$refs.modal.toggleModal(true)
    }
  }
}
</script>
<style lang="stylus">
.el-table__expanded-cell {
  padding: 0 !important;

  .el-table__empty-block {
    // display: none !important;
  }

  .el-table {
    background: #fafafa;

    tr {
      td {
        border-right: none;
      }

      background: #fafafa;
    }
  }
}
</style>
